import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { InvoiceCardComponent } from '../invoice-card/invoice-card.component';
import { ExpenseCardComponent } from '../expense-card/expense-card.component';

@Component({
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatIconModule, InvoiceCardComponent, ExpenseCardComponent],
  selector: 'income-expense-tabs',
  templateUrl: './income-expense-tabs.component.html',
  styleUrls: ['./income-expense-tabs.component.scss']
})
export class IncomeExpenseTabsComponent {
  selectedTabIndex = 0;
}
